export const DISPLAY_ALERT = 'SHOW_ALERT'
export const CLEAR_ALERT = 'CLEAR_ALERT'

export const LOGIN_USER_BEGIN = 'LOGIN_USER_BEGIN'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR'

export const LOGOUT_USER = 'LOGOUT_USER'

export const FORGET_PASSWORD_BEGIN = 'FORGET_PASSWORD_BEGIN'
export const FORGET_PASSWORD_SUCCESS = 'FORGET_PASSWORD_SUCCESS'
export const FORGET_PASSWORD_ERROR = 'FORGET_PASSWORD_ERROR'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const GET_STUDENTS_BEGIN = 'GET_STUDENTS_BEGIN'
export const GET_STUDENTS_SUCCESS = 'GET_STUDENTS_SUCCESS'
export const GET_STUDENTS_ERROR = 'GET_STUDENTS_ERROR'

export const CHANGE_PAGE = 'CHANGE_PAGE'
export const HANDLE_CHANGE = 'HANDLE_CHANGE'

export const GET_EXPIRED_STUDENTS_BEGIN = 'GET_EXPIRED_STUDENTS_BEGIN'
export const GET_EXPIRED_STUDENTS_SUCCESS = 'GET_EXPIRED_STUDENTS_SUCCESS'
export const GET_EXPIRED_STUDENTS_ERROR = 'GET_EXPIRED_STUDENTS_ERROR'

export const EXTEND_END_DATE_BEGIN = 'EXTEND_END_DATE_BEGIN'
export const EXTEND_END_DATE_SUCCESS = 'EXTEND_END_DATE_SUCCESS'
export const EXTEND_END_DATE_ERROR = 'EXTEND_END_DATE_ERROR'
